/**
 * defines and export the application router paths.
 */
export default Object.freeze({
    newspaperPageBase: '/newspapers',
    newspaperPage: '/newspapers/date/:date',
    newspaperMonthViewPage: '/newspapers/:publicationSlug/:publicationId',
    newspaperDetailPage: '/newspapers/protoselido-:publicationSlug/:date/:publicationId',
});
